import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "the-toasts" }

import { useToastStore } from '@/stores/toast';

import InfoIcon from '@/components/icons/other/InfoIcon.vue'
import CheckOutlinedIcon from './icons/other/CheckOutlinedIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheToasts',
  setup(__props) {

const toastStore = useToastStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toastStore).toasts, (toast, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: toast.id,
          class: _normalizeClass(["toast", [ toast.mode, toast.type ]]),
          style: _normalizeStyle({ top: index*56+'px' })
        }, [
          (toast.type === 'info')
            ? (_openBlock(), _createBlock(InfoIcon, { key: 0 }))
            : _createCommentVNode("", true),
          (toast.type === 'success')
            ? (_openBlock(), _createBlock(CheckOutlinedIcon, { key: 1 }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(toast.text), 1)
        ], 6))
      }), 128))
    ])
  ]))
}
}

})